import { IconChevronDown } from '@tabler/icons-react';

import { CSSProperties, ReactNode } from 'react';

import { Group, Menu, Text, UnstyledButton } from '@mantine/core';

export interface InsertAction {
    id: string;
    callback: () => void;
    icon: ReactNode;
    title: string;
    description: string;
}

interface InsertModeDropdownProps {
    actions: InsertAction[];
    disabled?: boolean;
}

const triggerStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 4px 2px 8px',
    borderRadius: 'var(--radius-medium, 4px)',
    backgroundColor: 'var(--basePageBg)',
    color: 'inherit',
    fontSize: 'var(--text-sm, 13px)',
    whiteSpace: 'nowrap',
    margin: '0 4px'
};

const InsertModeDropdown = ({ actions, disabled }: InsertModeDropdownProps) => {
    return (
        <Menu shadow='md' width={200}>
            <Menu.Target>
                <UnstyledButton style={{ ...triggerStyle, opacity: disabled ? 0.4 : 1, pointerEvents: disabled ? 'none' : undefined }}>
                    Insert Component
                    <IconChevronDown size={14} />
                </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Content Templates</Menu.Label>

                {actions.map(action => (
                    <Menu.Item
                        key={action.id}
                        leftSection={action.icon}
                        onClick={action.callback}
                    >
                        <Group gap='xs'>
                            <div>
                                <Text size='sm' fw={500}>
                                    {action.title}
                                </Text>
                                <Text size='xs' c='dimmed'>
                                    {action.description}
                                </Text>
                            </div>
                        </Group>
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
};

export default InsertModeDropdown;
